import { motion } from "framer-motion";
import { Bot, Coffee, Search } from "lucide-react";
import { Card, CardContent } from "./ui/card";

const features = [
  {
    icon: Bot,
    title: "Gestion automatisée 🧑💻",
    description: "Notre outil est plus simple qu'une trayeuse à vache. Même le petit Kévin, 12 ans, l'a maîtrisé en 5 min.",
  },
  {
    icon: Coffee,
    title: "Support humain ☕",
    description: "On répond plus vite que votre voisine curieuse. Et on a des cookies (en virtuel).",
  },
  {
    icon: Search,
    title: "Visibilité garantie 🔍",
    description: "Votre fiche apparaît avant les pubs pour la tondeuse. Même en Thiérache.",
  },
];

export const WhyChooseUs = ({ isPro }: { isPro: boolean }) => {
  if (!isPro) return null;

  return (
    <section className="py-12 px-4">
      <h2 className="text-3xl font-mono font-bold text-primary mb-12 text-center">
        Pourquoi Nous Choisir
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {features.map((feature, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2 }}
            viewport={{ once: true }}
          >
            <Card className="h-full">
              <CardContent className="p-6 text-center">
                <motion.div
                  whileHover={{ scale: 1.1 }}
                  className="mx-auto mb-4 w-16 h-16 bg-secondary/10 rounded-full flex items-center justify-center"
                >
                  <feature.icon className="w-8 h-8 text-secondary" />
                </motion.div>
                <h3 className="text-xl font-mono font-bold mb-2">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </CardContent>
            </Card>
          </motion.div>
        ))}
      </div>
    </section>
  );
};